module.exports = __webpack_public_path__ + "img/stadia-home-launch.8ddb39e3.webp";